import { defineMessages, IntlShape } from "react-intl";

import ImportStatus from "@mapmycustomers/shared/enum/imports/ImportStatus";
import Import from "@mapmycustomers/shared/types/imports/Import";

import doesImportHaveSkipFile from "./doesImportHaveSkipFile";

const titleMessages = defineMessages({
  [ImportStatus.COMPLETED]: {
    id: "imports.finalizeStep.status.completed.title",
    defaultMessage: "Import complete!",
    description: "Import status title - COMPLETED",
  },
  [ImportStatus.ERRORED]: {
    id: "imports.finalizeStep.status.errored.title",
    defaultMessage: "Something went wrong",
    description: "Import status title - ERRORED",
  },
  [ImportStatus.QUEUED]: {
    id: "imports.finalizeStep.status.queued.title",
    defaultMessage: "Nice work — we’ll start your import shortly",
    description: "Import status title - QUEUED",
  },
  [ImportStatus.RUNNING]: {
    id: "imports.finalizeStep.status.running.title",
    defaultMessage: "Nice work — your import is now in progress!",
    description: "Import status title - RUNNING",
  },
});

const getTitle = (intl: IntlShape, importRecord?: Import): string => {
  if (!importRecord) {
    return "";
  }
  if (doesImportHaveSkipFile(importRecord)) {
    return intl.formatMessage({
      id: "imports.finalizeStep.status.completedWithWarning.title",
      defaultMessage: "Your import is complete, but there were a few hiccups",
      description: "Import status sub title - COMPLETED WITH WARNINGS",
    });
  }
  return intl.formatMessage(titleMessages[importRecord.status]);
};

export default getTitle;
